var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4557",
    "data-name": "Group 4557",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.524,
    height: 20,
    viewBox: "0 0 23.524 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 23.524,
    height: 18,
    fill: "#fb7823"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M226.015,304.792v2.925a7.452,7.452,0,0,0-8.671.107,1.288,1.288,0,1,1-1.452-2.128,10.436,10.436,0,0,1,5.866-1.838,10.164,10.164,0,0,1,4.257.934",
    transform: "translate(-209.997 -296.339)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M116.378,151.078a13.593,13.593,0,0,1,4.257.676v2.675a11.283,11.283,0,0,0-4.257-.83,11.737,11.737,0,0,0-7.132,2.476,1.23,1.23,0,0,1-1.511-1.942,13.811,13.811,0,0,1,8.643-3.054",
    transform: "translate(-104.616 -147.339)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M802.6,259.585a1.226,1.226,0,0,1-.668.346v-2.6c.2.145.388.288.56.425a1.231,1.231,0,0,1,.108,1.83",
    transform: "translate(-782.086 -250.962)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M23.177,5.939l-.011.011a1.2,1.2,0,0,1-1.613.073,15.368,15.368,0,0,0-1.709-1.231V3.518a1.9,1.9,0,0,0-1.9-1.9h-.024a1.9,1.9,0,0,0-1.853,1.478A15.31,15.31,0,0,0,1.97,6.024,1.2,1.2,0,0,1,.357,5.95L.347,5.939A1.193,1.193,0,0,1,.409,4.2a17.445,17.445,0,0,1,22.706,0,1.193,1.193,0,0,1,.062,1.74",
    transform: "translate(0)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M334.377,459.467h0a1.277,1.277,0,0,1-1.5.239,3.71,3.71,0,0,0-3.577,0,1.286,1.286,0,0,1-1.2-2.275,6.054,6.054,0,0,1,5.978,0,1.287,1.287,0,0,1,.3,2.035",
    transform: "translate(-319.329 -445.342)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M420.451,613.4a1.428,1.428,0,1,1-1.428-1.428,1.428,1.428,0,0,1,1.428,1.428",
    transform: "translate(-407.262 -596.825)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M680.584,632.639a1.147,1.147,0,1,1-1.147-1.147,1.147,1.147,0,0,1,1.147,1.147",
    transform: "translate(-661.506 -615.866)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M678.063,106.7h-.024a1.17,1.17,0,0,1-1.17-1.17V96.04a1.17,1.17,0,0,1,1.17-1.17h.024a1.17,1.17,0,0,1,1.17,1.17v9.488a1.17,1.17,0,0,1-1.17,1.17",
    transform: "translate(-660.119 -92.522)",
    fill: "#fb7823"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlow);
export default __webpack_public_path__ + "static/media/slow.89037278.svg";
export { ForwardRef as ReactComponent };